export const validationsEnum = {
    "MINIMUM_VALUE": "minimumValue",
    "MAXIMUM_VALUE": "maximumValue",
    "ALLOW_FLOAT": "allowFloat",
    "IS_BOOLEAN": "isBoolean",
    "MINIMUM_LENGTH": "minimumLength",
    "MAXIMUM_LENGTH": "maximumLength",
    "REGEX": "regex"
}

Object.freeze(validationsEnum);